import React from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";

const customStyles = {
  control: (base, state) => ({
    ...base,
    backgroundColor: state.isDisabled ? "#f8fafc" : "white",
    borderColor: state.isDisabled ? "#e2e8f0" : "#d1d5db",
    fontSize: "0.875rem",
    minHeight: "2.5rem",
    boxShadow: "none",
    opacity: state.isDisabled ? 0.7 : 1,
    cursor: state.isDisabled ? "not-allowed" : "default",
    "&:hover": {
      borderColor: state.isDisabled ? "#e2e8f0" : "#9ca3af",
    },
  }),
  singleValue: (base, state) => ({
    ...base,
    color: state.isDisabled ? "#94a3b8" : "#111827",
  }),
  placeholder: (base, state) => ({
    ...base,
    color: state.isDisabled ? "#94a3b8" : "#64748b",
  }),
  multiValue: (base, state) => ({
    ...base,
    backgroundColor: state.isDisabled ? "#e2e8f0" : "#e8f1fb",
  }),
  multiValueLabel: (base, state) => ({
    ...base,
    color: state.isDisabled ? "#64748b" : "#144677",
    fontSize: "0.75rem",
    fontWeight: 600,
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? "#f3f4f6" : "white",
    color: "#111827",
    padding: "0.5rem 1rem",
    fontSize: "0.875rem",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const SelectDropdown = ({
  options = [],
  useServer = false,
  loadOptions, 
  onChange,
  value,
  isMulti = false,
  isClearable = true,
  isDisabled = false,
  isLoading = false,
  loadingMessage,
  placeholder = "Select...",
}) => {
  const SelectComponent = useServer ? AsyncSelect : Select;

  const filterOptions = (inputValue) => {
    return options.filter((opt) =>
      opt.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const promiseOptions = (inputValue) =>
    useServer
      ? loadOptions(inputValue)
      : new Promise((resolve) => {
          resolve(filterOptions(inputValue));
        });

  return (
    <SelectComponent
      styles={customStyles}
      isMulti={isMulti}
      isClearable={isClearable}
      isDisabled={isDisabled}
      isLoading={isLoading}
      placeholder={placeholder}
      loadOptions={promiseOptions}
      options={!useServer ? options : undefined}
      value={value}
      onChange={onChange}
      loadingMessage={() => loadingMessage || "Loading..."}
      closeMenuOnSelect={!isMulti}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      className="text-sm"
    />
  );
};

export default SelectDropdown;
